import appConfig from '@/app-config';
import { createClient, type ClientConfig } from '@sanity/client';

const config: ClientConfig = {
    ...appConfig.sanity,
};

export const SanityCMSClient = createClient(config);
